var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallArrowInRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#C691FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6785 13.3192L16.0719 22.5999L26.6785 31.8807",
    stroke: "#C691FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrowInRound);
export default __webpack_public_path__ + "static/media/small_arrow_in_round.52fa236928b9042a71a86d77cc01caca.svg";
export { ForwardRef as ReactComponent };